import { WEB_COMPONENT_SEARCHABLE_POLICY_PANEL_COMPONENT } from '../../../../../webcomponents.constants';
import { GzSearchablePolicyPanelWebComponent } from './component/GzSearchablePolicyPanelWebComponent';

export { GzSearchablePolicyPanelWebComponent };

window.customElements.define(WEB_COMPONENT_SEARCHABLE_POLICY_PANEL_COMPONENT, GzSearchablePolicyPanelWebComponent);
